import { createSelector } from 'reselect';
import { property } from 'lodash';

const configData = property('config');

export const isLoadingSelect = createSelector(configData, (data) => data.get('loading'));

export const configSelect = createSelector(configData, (data) => data.get('data'));

export const errorSelect = createSelector(configData, (data) => data.get('error'));
